import styled from 'styled-components';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

type EnterPlanModeStatus = 'pending' | 'accepted' | 'rejected';

type AiBuilderEnterPlanModeProps = {
  status: EnterPlanModeStatus;
  onApprove: () => Promise<void>;
  onReject: () => Promise<void>;
  isLoading?: boolean;
};

export function AiBuilderEnterPlanMode({
  status,
  onApprove,
  onReject,
  isLoading,
}: AiBuilderEnterPlanModeProps) {
  const { t } = useScopedTranslate(locale);
  const isPending = status === 'pending';

  return (
    <PlanModeCard>
      <Text font="regular14" text={t('description')} color="textPrimary" />
      <Footer>
        <Button
          variant="secondary"
          text={t('reject')}
          onClick={onReject}
          isDisabled={!isPending || isLoading}
        />
        <Button
          variant="primary-blue"
          text={t('approve')}
          onClick={onApprove}
          isDisabled={!isPending || isLoading}
        />
      </Footer>
    </PlanModeCard>
  );
}

const PlanModeCard = styled.div({
  width: '100%',
  border: `1px solid ${theme.color.border10}`,
  borderRadius: pxToRem(8),
  padding: pxToRem(16),
  background: theme.color.backgroundPrimary,
});

const Footer = styled(Stack).attrs({
  orientation: 'horizontal',
  justify: 'flex-end',
  space: 2,
})({
  marginTop: pxToRem(16),
});

const locale = {
  en: {
    description:
      'The agent wants to switch to Plan mode to map out the feature before making changes.',
    reject: 'Reject',
    approve: 'Approve',
  },
};
